import { FC } from 'react';
import { StanButton } from '../../StanButton/StanButton';
import { StanLoader } from '../../StanLoader/StanLoader';
import { AISuggestionBlockProps } from '../types';
import styles from './AISuggestionBlock.module.css';

// Import icons - we'll use SVG assets from the project
import IcWarningCircle from '@/assets/icons/ic-warning-circle.svg';
import IcStanleyProfile from '@/assets/icons/ic-stanley-profile.svg';
import { cn } from '@/lib/utils/cn';

export const AISuggestionBlock: FC<AISuggestionBlockProps> = ({
    state,
    suggestion,
    onAccept,
    onDismiss,
    onRetry,
    className,
}) => {
    return (
        <div
            id='ai-suggestion-block'
            className={cn(
                styles.aiBlock,
                state === 'error' && styles.error,
                state === 'loading' && styles.loading,
                state === 'success' && styles.success,
                className
            )}
        >
            {state === 'loading' && (
                <div className={styles.loadingContainer}>
                    <StanLoader className={styles.icon} dotSize={8} color='var(--bg-color-primary-brand-main)' />
                    <div className={styles.text}>Generating...</div>
                    <button type='button' className={styles.cancelButton} onClick={onDismiss}>
                        Cancel
                    </button>
                </div>
            )}

            {state === 'error' && (
                <div className={styles.errorContainer}>
                    <div className={styles.icon}>
                        <IcWarningCircle className={styles.warningIcon} />
                    </div>
                    <div className={styles.text}>Failed to reach Stanley.</div>
                    {onRetry && (
                        <button type='button' className={styles.retryButton} onClick={onRetry}>
                            Try Again
                        </button>
                    )}
                </div>
            )}

            {state === 'success' && suggestion && (
                <div className={styles.suggestionContainer}>
                    <IcStanleyProfile className={styles.stanleyIcon} />
                    <div className={styles.content}>
                        <div className={styles.suggestionText} dangerouslySetInnerHTML={{ __html: suggestion }} />
                        <div className={styles.buttons}>
                            <StanButton name='tiptap-editor-ai-accept' size='xs' variant='outline' onClick={onAccept}>
                                Replace
                            </StanButton>
                            <StanButton
                                name='tiptap-editor-ai-dismiss'
                                size='xs'
                                variant='outline'
                                color='secondary'
                                onClick={onDismiss}
                            >
                                Dismiss
                            </StanButton>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
